import { ListColumnName } from "@/types/front/ListColumnName";
import { ref, Ref } from "vue";
import i18n from "@/i18n";

/**
 * Résolveur de label localisé pour les colonnes de la table d'autorisations
 * ( Suppression / Dépôt / Extraction / Publication ) . Source de vérité
 * unique pour la traduction , consommée par les composants qui rendent
 * ces colonnes ( AuthorizationsForNoAuthorization , AuthorizationTableForOneDataType ,
 * SummaryTableOfAuthorizationByData ) .
 *
 * <p>Convention de clés : `dataTypeAuthorizations.operations.<title>` où
 * `title` vient de la définition `getListColumnName` ( delete , depot ,
 * extraction , publication ) . Conforme à la convention i18n existante
 * du projet ( sous-objet nesté pour grouper sémantiquement , cf.
 * `additionalFilesManagement.buttons.{delete,download,...}` ) .
 *
 * <p>Si la clé est absente du dictionnaire i18n , vue-i18n renvoie la
 * clé brute - signal visible pour ajouter la traduction manquante .
 *
 * <p>OCP : ajouter une nouvelle opération = ajouter une entrée dans
 * `getListColumnName` + 2 traductions ( fr.json et en.json ) . Helper
 * inchangé . Ajouter une nouvelle langue = ajouter le dictionnaire i18n .
 */
export function getLocalizedColumnName(
  column: { title?: string } | undefined | null,
): string {
  const title = column?.title;
  if (!title) return "";
  return i18n.global.t(`dataTypeAuthorizations.operations.${title}`) as string;
}

export function getListColumnName(): Ref<ListColumnName> {
  return ref<ListColumnName>({
    withoutScope: {
      delete: {
        display: true,
        title: "delete",
        withPeriods: false,
        withDataGroups: false,
        forPublic: false,
        forRequest: false,
        internationalizationName: {
          fr: "Suppression",
          en: "Deletion",
        },
      },
      depot: {
        display: true,
        title: "depot",
        withPeriods: false,
        withDataGroups: false,
        forPublic: false,
        forRequest: false,
        internationalizationName: {
          fr: "Dépôt",
          en: "Deposit",
        },
      },
      extraction: {
        display: true,
        title: "extraction",
        withPeriods: true,
        withDataGroups: true,
        forPublic: true,
        forRequest: true,
        internationalizationName: {
          fr: "Extraction",
          en: "Extraction",
        },
      },
    },
    withScope: {
      delete: {
        display: true,
        title: "delete",
        withPeriods: false,
        withDataGroups: false,
        forPublic: false,
        forRequest: false,
        internationalizationName: {
          fr: "Suppression",
          en: "Deletion",
        },
      },
      depot: {
        display: true,
        title: "depot",
        withPeriods: false,
        withDataGroups: false,
        forPublic: false,
        forRequest: false,
        internationalizationName: {
          fr: "Dépôt",
          en: "Deposit",
        },
      },
      publication: {
        display: true,
        title: "publication",
        withPeriods: false,
        withDataGroups: false,
        forPublic: false,
        forRequest: false,
        internationalizationName: {
          fr: "Publication",
          en: "Publication",
        },
      },
      extraction: {
        display: true,
        title: "extraction",
        withPeriods: true,
        withDataGroups: true,
        forPublic: true,
        forRequest: true,
        internationalizationName: {
          fr: "Extraction",
          en: "Extraction",
        },
      },
    },
  });
}
